<template>
  <div style="overflow: hidden; background: #f2f2f2">
    <div class="title">基本信息/General lnformation</div>
    <div class="content updataCss">
      <div class="cell" id="company">
        <span>公司/Company Name</span>
        <input
          type="text"
          placeholder="请输入/Please enter"
          v-model="company"
        />
      </div>
      <div class="cell" id="name">
        <span>联系人/Contact</span>
        <input type="text" placeholder="请输入/Please enter" v-model="name" />
      </div>
      <div class="cell" id="job">
        <span>职务/Position</span>
        <input type="text" placeholder="请输入/Please enter" v-model="job" />
      </div>
      <div class="cell" id="phone">
        <span>手机号/Contact Number</span>
        <input
          type="text"
          placeholder="请输入/No contact number no need enter"
          maxlength="11"
          v-model="phone"
        />
      </div>
      <div class="cell" id="email">
        <span>邮箱/Email</span>
        <input type="text" placeholder="请输入/Please enter" v-model="Email" />
      </div>
      <div class="cell" id="address">
        <span>地址/Country</span>
        <input
          type="text"
          placeholder="请输入/Please enter"
          v-model="address"
        />
      </div>
      <div class="cell" id="creditCode">
        <span>信用代码/Social Credi</span>
        <input
          type="text"
          placeholder="请输入/No Social Credi no need enter"
          v-model="creditCode"
        />
      </div>
    </div>

    <div class="title">
      开票信息/Invoicing
      <span>
        <Checkbox
          v-model="singleInvoicing"
          style="font-size: 0.26rem; margin-left: 20%; color: #ee1c5d"
          >暂不填写/No invoice</Checkbox
        >
      </span>
    </div>
    <div class="content updataCss" v-if="!singleInvoicing">
      <div class="cell" id="invoiceTitle">
        <span>发票抬头</span>
        <input
          type="text"
          placeholder="请输入/Please enter"
          v-model="invoiceTitle"
        />
      </div>
      <div class="cell" id="invoiceCode">
        <span>税号</span>
        <input
          type="text"
          placeholder="请输入/Please enter"
          v-model="invoiceCode"
        />
      </div>
      <div class="cell" id="invoiceAddress">
        <span>单位地址</span>
        <input
          type="text"
          placeholder="请输入/Please enter"
          v-model="invoiceAddress"
        />
      </div>
      <div class="cell" id="invoiceTelephone">
        <span>电话号码</span>
        <input
          type="text"
          placeholder="请输入/Please enter"
          v-model="invoiceTelephone"
        />
        <!-- maxlength="11" -->
      </div>
      <div class="cell" id="invoiceBank">
        <span>开户银行</span>
        <input
          type="text"
          placeholder="请输入/Please enter"
          v-model="invoiceBank"
        />
      </div>
      <div class="cell" id="invoiceBankAccount">
        <span>银行账户</span>
        <input
          type="text"
          placeholder="请输入/Please enter"
          v-model="invoiceBankAccount"
        />
      </div>
      <div
        class="cell exhibitionarea"
        style="margin-left: 0rem; border-bottom: 1px solid #fff"
        id="creditCode"
      >
        <span>发票类型</span>
        <!-- <div class="exhibitionInvoice">
          <span class="span1">填充发票信息</span>
        </div> -->
      </div>
      <div class="invoiceRadio">
        <RadioGroup v-model="invoiceType" vertical>
          <Radio label="增值税专用发票">
            <Icon type="social-apple"></Icon>
            <span>增值税专用发票</span>
          </Radio>
          <Radio label="增值税普通发票">
            <Icon type="social-android"></Icon>
            <span>增值税普通发票</span>
          </Radio>
        </RadioGroup>
        <p style="color: #ee1c5d; font-size: 0.26rem; height: 70px">
          注:报名成功后，我们将按照以上开票信息进行开票
        </p>
      </div>

      <!-- <FormItem label="开票类型"
                      prop="invoiceType"
                      id="invoiceType">
              <RadioGroup v-model="formInline.invoiceType"
                          @on-change="changeInvoice">
                <Radio label="增值税专票">
                  <span>专票</span>
                </Radio>
                <Radio label="增值税普票">
                  <span>普票</span>
                </Radio>
              </RadioGroup>
            </FormItem> -->
    </div>

    <div class="title" style="padding-top: 20px" id="exhibitionarea">
      展会选择/Select Exhibition
    </div>
    <div class="exhibitionarea updataCss">
      <div
        class="exhibition1"
        v-for="(item, index) in exhibitionList"
        :key="index + '1'"
        :class="{ is_active: index == exIndex }"
        @click="changeEx(item.id, index)"
      >
        <span class="span1">{{ item.name }}/ {{ item.nameEn }}</span>
      </div>
    </div>

    <!-- 展区选择 -->
    <div class="title">展区选择/Please select your exhibition area</div>
    <div
      class="exhibitionarea updataCss"
      id="booth"
      v-if="exhibitionArea.length"
    >
      <div v-for="(item, index) in exhibitionArea" :key="index + '1'">
        <div
          class="exhibition1"
          :class="{ is_active: index == exAreaIndex }"
          @click="changeExArea(item.id, index, item.name, item)"
          v-if="item.languageType == '中文' && item.isEnable"
        >
          <span class="span1">{{ item.name }}</span>
        </div>
      </div>
      <div
        v-if="exhibitionId == 'e9defafb-5d6b-42d2-b523-c2abad413c75'"
        style="
          padding: 0.1rem 0.3rem;
          font-size: 0.24rem;
          color: #666;
          display: block;
        "
      >
        康复、养老及家用医疗区（请在上栏展会选择2022国际康复养老及家用医疗展进行展位申报）
      </div>
    </div>
    <div class="loadingText" v-else>加载中....</div>

    <!-- 币种 -->
    <div v-if="currencyShow">
      <div class="title">Please select currency</div>
      <div class="exhibitionarea updataCss">
        <div
          class="exhibition1"
          v-for="(item, index) in currencyType"
          :key="index + '1'"
          :class="{ is_active: index == currencyIndex }"
          @click="changeCurrency(item, index)"
        >
          <span class="span1">{{ item.name }} Booking</span>
        </div>
      </div>
    </div>

    <!-- 组 -->
    <div v-if="currencyShow">
      <div class="title">Please select your exhibition group</div>
      <div class="exhibitionarea updataCss">
        <div
          class="exhibition1"
          v-for="(item, index) in directImportList"
          :key="index + '1'"
          :class="{ is_active: index == directImportIndex }"
          @click="changeDirectImport(item, index)"
        >
          <span class="span1">{{ item.name }}</span>
        </div>
      </div>
    </div>
    <!-- 选第二个的时候 -->
    <div v-if="pavilion">
      <div class="title">Continue to select the pavilion</div>
      <div class="exhibitionarea updataCss">
        <div
          class="exhibition1"
          v-for="(item, index) in languageEnListOther"
          :key="index + '1'"
          :class="{ is_active: index == pavilionIndex }"
          @click="changePavilion(item, index)"
        >
          <span class="span1">{{ item.name }}</span>
        </div>
      </div>
    </div>

    <Input
      v-model="remark"
      placeholder="请输入产品类型"
      v-if="inputShow"
      style="width: 4rem; margin: 0 0 0.3rem 0.3rem"
    />
    <div class="title" v-if="exhibitionBoothNew.length">
      {{ currencyShow ? "Please select booth type" : "展位预定" }}
    </div>
    <div class="updataCss">
      <div v-for="(item3, index3) in exhibitionBoothNew" :key="index3">
        <div class="reserve">
          <div style="padding: 0.36rem 0">
            <Checkbox
              v-model="item3.isCheck"
              :label="item3.name"
              @on-change="changeBox(item3, $event, index3)"
            >
            </Checkbox>

            <span class="reserve_span1">{{ item3.name }}</span>
            <!-- <span class="reserve_span2" v-if="item3.remarkList.length > 0">{{
              item3.remarkList[0]
            }}</span> -->
            <span class="reserve_span3"
              >{{ item3.price }}{{ item3.currencyKind }}/{{ item3.unit }}</span
            >
          </div>

          <!-- <div
            v-if="item3.remarkList[1]"
            style="font-size: 0.26rem; margin-left: 0.3rem; color: #ee1c5d"
          >
            {{ item3.remarkList[1] }}
          </div> -->
          <div
            style="width: 100%; height: 1px; background-color: #e5e5e5"
          ></div>

          <!--展位面积-->
          <div class="area" v-if="item3.isCheck">
            <span class="area-title">
              {{ currencyShow ? "Booth area" : "展位面积" }}</span
            >
            <div style="margin-top: 0.36rem">
              <span style="font-size: 0.24rem">
                {{ currencyShow ? "Width" : "面宽" }}</span
              >
              <Input
                v-model="item3.Width"
                style="width: 1.4rem; margin: 0 0.1rem"
                @on-change="exwidth(item3.Width)"
                maxlength="4"
                type="number"
              />
              <span style="margin-right: 0.5rem">
                {{ currencyShow ? "m" : "米" }}</span
              >
              <span style="margin-right: 0.5rem">X</span>
              <span style="font-size: 0.24rem">
                {{ currencyShow ? "Depth" : "进深" }}</span
              >
              <Input
                v-model="item3.Height"
                style="width: 1.4rem; margin: 0 0.1rem"
                @on-change="exheight(item3.Height)"
                maxlength="4"
                type="number"
              />
              <span style="font-size: 0.24rem">
                {{ currencyShow ? "m" : "米" }}</span
              >
            </div>
            <div style="margin-top: 0.3rem; padding-bottom: 0.5rem">
              <span style="font-size: 0.24rem">
                {{ currencyShow ? "area" : "面积" }}</span
              >
              <div
                style="
                  display: inline-block;
                  width: 1.4rem;
                  height: 0.64rem;
                  background-color: #f2f2f2;
                  border-radius: 0.1rem;
                  border: solid 1px #cccccc;
                  line-height: 0.64rem;
                  padding-left: 4px;
                  margin: 0 0.1rem;
                "
              >
                {{ item3.Width * item3.Height }}
              </div>
              <span>{{ currencyShow ? "㎡" : "平米" }}</span>
            </div>
            <div class="total">
              <span v-if="item3.boothArea > 1"
                >{{ currencyShow ? "Total" : "合计" }}：{{
                  (
                    (item3.Width * item3.Height * item3.price) /
                    item3.boothArea
                  ).toFixed()
                }}{{ item3.currencyKind }}</span
              >
              <span v-else
                >{{ currencyShow ? "Total" : "合计" }}：{{
                  item3.Width * item3.Height * item3.price
                }}
                {{ item3.currencyKind }}</span
              >
            </div>
            <div
              style="width: 100%; height: 1px; background-color: #e5e5e5"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div class="title" v-if="otherList.length > 0 && otherList">
      {{ currencyShow ? "Obligatory" : "固定费用" }}
    </div>
    <div class="updataCss">
      <div
        class="exhibition1"
        v-for="(other, index) in otherList"
        :key="index + '1'"
        v-if="languageEnListCurrent == other.groupLanguage"
      >
        <div class="reserve">
          <div style="padding: 0.36rem 0">
            <Checkbox
              v-model="other.isCheck"
              :label="other.name"
              :disabled="true"
            ></Checkbox>

            <span class="reserve_span1">{{ other.name }}</span>
          </div>
        </div>

        <div class="table">
          <div class="table-child">
            {{ currencyShow ? "Price" : "单价" }}:
            <span style="color: #ee1c5d"
              >{{ other.price }}{{ other.currencyKind }}/{{ other.unit }}</span
            >
          </div>
          <div class="table-child">
            {{ currencyShow ? "Unit Price" : "个数" }}
            <div
              style="
                display: inline-block;
                width: 1.4rem;
                height: 0.64rem;
                background-color: #f2f2f2;
                border-radius: 0.1rem;
                border: solid 1px #cccccc;
                line-height: 0.64rem;
                padding-left: 4px;
                margin: 0 0.1rem;
              "
            >
              {{ other.minBuy }}
            </div>
            {{ other.cunit }}
          </div>
          <div class="table-child" style="margin-bottom: 0.2rem">
            {{ currencyShow ? "total" : "总价" }} :
            {{ other.minBuy * other.price }}
            {{ other.currencyKind }}
          </div>
        </div>

        <div style="width: 100%; height: 1px; background-color: #e5e5e5"></div>
      </div>
    </div>
    <div class="title" v-if="onlineList.length > 0">
      {{
        currencyShow
          ? "Select Online Valued-added Services"
          : "请选择线上市场增值服务项目"
      }}
      <span style="color: #ee1c5d; display: block; font-size: 14px"
        >(根据需求选择意向合作的内容，我们会联系您)</span
      >
    </div>
    <div class="updataCss" :key="componentKey">
      <div
        class="exhibition1"
        v-for="(online, index) in onlineList"
        :key="index + '1'"
        v-if="languageEnListCurrent == online.groupLanguage && online.isEnable"
      >
        <!-- <div v-if="online.typeLanguage == '中文'"> -->
        <div class="top">
          <div class="l">
            <div>
              <Checkbox
                size="large"
                @on-change="allChoose(online, $event)"
                v-model="online.isCheck"
              ></Checkbox>
            </div>
            <div>{{ online.groupName }}</div>
          </div>
          <div
            class="r"
            v-if="!online.isPack && onlineList.length > 0"
            @click="(online.isPack = !online.isPack), componentKey++"
          >
            展开
            <i
              class="icon iconfont icon-expanding"
              style="transform: rotate(90deg)"
            ></i>
          </div>
          <div
            class="r"
            v-else-if="onlineList.length > 0"
            @click="(online.isPack = !online.isPack), componentKey++"
          >
            收起
            <i
              class="icon iconfont icon-expanding"
              style="transform: rotate(-90deg)"
            ></i>
          </div>
        </div>
        <div v-if="online.isPack">
          <div class="reserve">
            <div style="padding: 0">
              <Checkbox
                size="large"
                @on-change="allChoose(online, $event)"
                v-model="online.isCheck"
              ></Checkbox>

              <span class="reserve_span1">{{ online.name }}</span>
            </div>
          </div>

          <div class="table">
            <!-- <div class="table-child">
              <span v-if="onlineChild.durationType === '时间段'"
                >输入时间段：</span
              >
              <span v-if="onlineChild.durationType === '时长'">选择时长：</span>
              <div v-if="onlineChild.durationType === '时间段'">
                <span>开始时间：</span>
                <Input
                  v-model="onlineChild.beginTime"
                  style="width: 2rem; margin: 0 0.1rem; font-size: 0.24rem"
                  type="text"
                />
                示例(2021-05-13)
              </div>
              <div
                style="margin-top: 0.2rem"
                v-if="onlineChild.durationType === '时间段'"
              >
                <span>结束时间：</span>
                <Input
                  v-model="onlineChild.endTime"
                  style="width: 2rem; margin: 0 0.1rem; font-size: 0.24rem"
                  type="text"
                />
              </div>
              <template v-if="onlineChild.durationType === '时长'">
                <Select
                  v-model="onlineChild.durationValue"
                  style="width: 2rem"
                  @click.stop.native
                >
                  <Option
                    v-for="im in onlineChild.durationList"
                    :value="im"
                    :key="im"
                    >{{ im }}
                  </Option> </Select
                >&nbsp;&nbsp;&nbsp;{{ onlineChild.durationUnit }}
              </template>
            </div> -->
            <div class="table-child">
              {{ currencyShow ? "Price" : "单价" }}:
              <span style="color: #ee1c5d"
                >{{ online.price }}{{ online.currencyKind }}/{{
                  online.unit
                }}</span
              >
            </div>
            <div class="table-child">
              {{ currencyShow ? "Unit Price" : "个数" }}
              <Input
                v-model="online.orderNum"
                style="width: 1.4rem; margin: 0 0.1rem"
                @on-change="changeNumber(online)"
                maxlength="4"
                type="number"
              />
              {{ online.unit }}
            </div>
            <div class="table-child" style="margin-bottom: 0.3rem">
              {{ currencyShow ? "total" : "总价" }} :
              {{ online.orderNum * online.price }}
              {{ online.currencyKind }}
            </div>
          </div>

          <div
            style="width: 100%; height: 1px; background-color: #e5e5e5"
          ></div>
        </div>
      </div>
    </div>
    <div class="title" v-if="offlineList.length > 0">
      {{
        currencyShow
          ? "Select Ofline Valued-added Services"
          : "请选择线下市场增值服务项目"
      }}
      <span style="color: #ee1c5d; display: block; font-size: 14px"
        >(根据需求选择意向合作的内容，我们会联系您)</span
      >
    </div>
    <div class="updataCss" :key="componentKeyDown">
      <div
        class="exhibition1"
        v-for="(offline, index) in offlineList"
        :key="index + '1'"
        v-if="
          languageEnListCurrent == offline.groupLanguage && offline.isEnable
        "
      >
        <div class="top">
          <div class="l">
            <div>
              <Checkbox
                size="large"
                @on-change="allChoose(offline, $event)"
                v-model="offline.isCheck"
              ></Checkbox>
            </div>
            <div>{{ offline.groupName }}</div>
          </div>
          <div
            class="r"
            v-if="!offline.isPack && offlineList.length > 0"
            @click="(offline.isPack = !offline.isPack), componentKeyDown++"
          >
            展开
            <i
              class="icon iconfont icon-expanding"
              style="transform: rotate(90deg)"
            ></i>
          </div>
          <div
            class="r"
            v-else-if="offlineList.length > 0"
            @click="(offline.isPack = !offline.isPack), componentKeyDown++"
          >
            收起
            <i
              class="icon iconfont icon-expanding"
              style="transform: rotate(-90deg)"
            ></i>
          </div>
        </div>
        <div v-if="offline.isPack && offlineList.length > 0">
          <div class="reserve">
            <div style="padding: 0">
              <Checkbox
                size="large"
                @on-change="allChoose(offline, $event)"
                v-model="offline.isCheck"
              ></Checkbox>

              <span class="reserve_span1">{{ offline.name }}</span>
            </div>
          </div>

          <div class="table">
            <div class="table-child">
              {{ currencyShow ? "Price" : "单价" }}:
              <span style="color: #ee1c5d"
                >{{ offline.price }}{{ offline.currencyKind }}/{{
                  offline.unit
                }}</span
              >
            </div>
            <div class="table-child">
              {{ currencyShow ? "Unit Price" : "个数" }}
              <Input
                v-model="offline.orderNum"
                style="width: 1.4rem; margin: 0 0.1rem"
                @on-change="changeNumber(offline)"
                maxlength="4"
                type="number"
              />
              {{ offline.unit }}
            </div>
            <div class="table-child" style="margin-bottom: 0.3rem">
              {{ currencyShow ? "total" : "总价" }}:
              {{ offline.orderNum * offline.price }}
              {{ offline.currencyKind }}
            </div>
          </div>

          <div
            style="width: 100%; height: 1px; background-color: #e5e5e5"
          ></div>
        </div>
      </div>
    </div>
    <div
      style="padding: 0.2rem 0.3rem; font-size: 0.3rem; color: #666"
      class="updataCss"
    >
      <div>
        {{
          currencyShow
            ? "Sum of Online/Offline Valued-added Services"
            : "线上线下市场增值服务订单小计"
        }}：{{ price }} {{ currencyShow ? currencyTypeName : "元" }}
      </div>

      <div>
        {{ currencyShow ? "Sum of Booth Orders" : "展位订单小计" }}：{{
          boothprice || 0
        }}
        {{ currencyShow ? currencyTypeName : "元" }}
      </div>
      <div>
        {{ currencyShow ? "Obligatory" : "固定费用：" }}：{{ gudingprice }}
        {{ currencyShow ? currencyTypeName : "元" }}
      </div>
      <div>
        {{ currencyShow ? "Total" : "订单合计：" }}：{{
          price + boothprice + gudingprice
        }}
        {{ currencyShow ? currencyTypeName : "元" }}
      </div>
    </div>
    <div class="submitbtn">
      <div class="btn" @click="submit" v-if="!display">
        <span>{{
          currencyShow
            ? "ldentify and submit the application"
            : "确定并提交申请"
        }}</span>
      </div>
      <div class="btn-dis" v-else>
        <span>{{
          currencyShow
            ? "ldentify and submit the application"
            : "确定并提交申请"
        }}</span>
      </div>
    </div>
  </div>
</template>

<script src="https://res.wx.qq.com/open/js/jweixin-1.0.0.js"></script>

<script>
// (function () {
//   function w() {
//     var r = document.documentElement;
//     var a = r.getBoundingClientRect().width; //获取当前设备的宽度
//     if (a > 750) {
//       //720不固定，根据设计稿的宽度定
//       a = 750;
//     }
//     let rem = a / 7.5;
//     r.style.fontSize = rem + "px";
//   }
//   w();
//   window.addEventListener(
//     "resize",
//     function () {
//       //监听横竖屏切换
//       w();
//     },
//     false
//   );
// })();

import axios from "axios";
import { mapActions } from "vuex";
let moment = require("moment");
export default {
  name: "index",
  data() {
    return {
      getDeTermGetListId: [],
      DeTermIdEx: "",
      languageEnListCurrent: "中文",
      // 发票参数
      singleInvoicing: false,
      invoiceType: "",
      invoiceTitle: "",
      invoiceCode: "",
      invoiceAddress: "",
      invoiceTelephone: "",
      invoiceBank: "",
      invoiceBankAccount: "",
      exhibitionBoothNew: [],
      exIndex: 0,
      exAreaIndex: 0,
      company: "",
      name: "",
      job: "",
      phone: "",
      Email: "",
      address: "",
      DePjName: "",
      UnitPrice: "",
      Unit: "",
      exarea: 1, //面积
      inputShow: false,
      other: "",
      price: 0,
      componentKey: 1,
      componentKeyDown: 999,
      gudingprice: 0,
      boothprice: 0,
      creditCode: "",
      exhibitionName: "",
      exhibitionId: "", //展会ID
      exhibitionAreaId: "", //展区ID
      exhibitionList: [], //展会列表
      exhibitionArea: [], //展区列表
      exhibitionBooth: [], //展位列表
      otherList: [], //固定费用列表
      onlineList: [], //线上费用
      offlineList: [], //线下
      chooseArr: [], //选择的增值服务
      boothSelect: [], //选中的展位
      isAllChoose: [],
      applyCompanyId: "",
      applyCompanyOrderId: "",
      chooseOtherArr: [], //选中的其他订单
      inputShow: false,
      remark: "",
      fixId: "",
      display: false, //按钮禁用
      changeLoading: false, //切换

      currencyShow: false,
      currencyType: [
        {
          name: "RMB",
        },
        {
          name: "USD",
        },
      ],
      currencyIndex: 3,
      currencyTypeName: "",

      directImportList: [
        {
          // name: 'International direct sales'
          name: "International Sales",
        },
        {
          name: "International Pavilion",
        },
      ],
      directImportIndex: 3,
      directImportName: "",

      pavilionIndex: 30,
      pavilionName: "",
      pavilion: false,

      languageEnList: [],
      showEnOrderList: [],
      languageEnListOther: [], //除去固定的展区
    };
  },
  components: {},
  computed: {
    userId() {
      return this.$route.query.userId;
    },
  },
  created() {
    document.title = "现场展位预定";
    this.init();
    if (this.userId) {
      this.getInfo();
    }

    // let timestamp = Math.floor(Date.now() / 1000).toString();
    // let nonceStr = Math.random().toString(36).substr(2, 15);
    // let params = {
    //   timestamp: timestamp,
    //   nonceStr: nonceStr,
    //   // 其他需要参与签名的参数
    // };
    // let sortedParams = Object.keys(params)
    //   .sort()
    //   .map(function (key) {
    //     return key + "=" + params[key];
    //   })
    //   .join("&");

    //   let urlA = 'https://i.cmef.com.cn/basic/mobile'
    // let url =urlA.split("#")[0];
    // // let url = window.location.href.split("#")[0];
    // console.log(url);
    // let signature = "";
    // // 使用服务器端接口获取微信签名
    // // 可以使用axios、fetch等工具发送GET请求到服务器端获取签名
    // axios
    //   .get("/getSignature", {
    //     params: {
    //       url: url,
    //       params: sortedParams,
    //     },
    //   })
    //   .then(function (response) {
    //     debugger
    //     signature = response.data.signature;
    //     // 微信签名获取成功，继续后续操作
    //   })
    //   .catch(function (error) {
    //     console.error(error);
    //     // 微信签名获取失败，处理错误
    //   });

    // wx.config({
    //   appId: "你的AppID",
    //   timestamp: "生成签名的时间戳",
    //   nonceStr: "生成签名的随机串",
    //   signature: "签名",
    //   jsApiList: ["chooseInvoiceTitle"],
    // });
  },
  methods: {
    ...mapActions({
      ApplyScene: "ApplyScene",
      getApplyExhibition: "getApplyExhibition",
      getDePjNameGroup: "getDePjNameGroup",
      getDeTermGetListByType: "getDeTermGetListByType",
      getForeignList: "getForeignList",
      getApplyCompanyBasic: "getApplyCompanyBasic", //获取基本信息
      addApplyCompany: "addApplyCompany", //提交基本信息
      applyCompanyOrder: "applyCompanyOrder", //获取订单ID
      addApplyOrder: "addApplyOrder",
      finishApplyOperate: "finishApplyOperate",

      getAllArea: "getAllArea", //获取展区列表
      getCommodities: "getCommodities", //获取商品信息
      OrderChangeState: "OrderChangeState",
    }),

    // 获取基本信息
    async getInfo() {
      let basicInfo = await this.getApplyCompanyBasic(this.userId);

      console.log("基本信息：", basicInfo);

      this.company = basicInfo.companyName;
      this.name = basicInfo.linkMan;
      this.job = basicInfo.linkTitle;
      this.phone = basicInfo.linkMob;
      this.Email = basicInfo.linkEmail;
      this.address = basicInfo.address;
      this.creditCode = basicInfo.unifiedCode;
      if (basicInfo.isInvoice == "false") {
        this.singleInvoicing = false;
      } else {
        this.singleInvoicing = true;
      }
      this.invoiceType = basicInfo.invoiceType;
      this.invoiceTitle = basicInfo.invoiceTitle;
      this.invoiceCode = basicInfo.invoiceCode;
      this.invoiceAddress = basicInfo.invoiceAddress;
      this.invoiceTelephone = basicInfo.invoiceTelephone;
      this.invoiceBank = basicInfo.invoiceBank;
      this.invoiceBankAccount = basicInfo.invoiceBankAccount;
    },

    getboothPrice() {
      if (this.boothSelect && this.boothSelect.boothArea > 1) {
        this.boothprice = parseInt(
          (
            (this.boothSelect.Width *
              this.boothSelect.Height *
              this.boothSelect.price) /
            this.boothSelect.boothArea
          ).toFixed()
        );
      } else {
        this.boothprice = parseInt(
          this.boothSelect.Width *
            this.boothSelect.Height *
            this.boothSelect.price
        );
      }
    },
    exwidth(width) {
      this.boothSelect.Width = width;
      if (width) {
        this.getboothPrice();
      }
    },
    exheight(height) {
      this.boothSelect.Height = height;
      if (height) {
        this.getboothPrice();
      }
    },
    changeNumber(item) {
      this.price = 0;
      this.chooseArr.forEach((e) => {
        if (e.orderNum && e.price) {
          this.price += e.orderNum * e.price;
        }
      });
    },
    allChoose(e, value) {
      // this.ChooseCheck=value
      this.componentKey++;
      this.componentKeyDown++;
      if (value) {
        e.isPack = true;
      } else {
        e.isPack = false;
      }
      if (e.isPack !== false) {
        this.chooseArr.push(e);
      } else if (value == false) {
        this.chooseArr.forEach((item, index) => {
          if (item.id == e.id) {
            this.chooseArr.splice(index, 1);
          }
        });
      }
      if (this.chooseArr.length > 0) {
        this.chooseArr.forEach((e) => {
          if (e.orderNum && e.price) {
            this.price += e.orderNum * e.price;
          }
        });
      } else {
        this.price = 0;
      }

      console.log(this.chooseArr);
    },
    //选择线上订单
    onlineChange(item, e, curent) {
      curent.isCheck = e;
      this.price = 0;
      if (e) {
        this.chooseArr.push(item);
      } else {
        this.chooseArr.splice(this.chooseArr.indexOf(item.id), 1);
      }

      this.chooseArr.forEach((e) => {
        if (e.orderNum && e.price) {
          this.price += e.orderNum * e.price;
        }
      });

      if (this.chooseArr.length > 0) {
        this.chooseArr.forEach((e) => {
          if (e.orderNum && e.price) {
            this.price += e.orderNum * e.price;
          }
        });
      } else {
        this.price = 0;
      }
      console.log(this.chooseArr);
    },
    //选择线下订单
    offlineChange(item, e, curent) {
      curent.isCheck = e;
      this.price = 0;
      if (e) {
        this.chooseArr.push(item);
      } else {
        this.chooseArr.splice(this.chooseArr.indexOf(item.id), 1);
      }
      this.chooseArr.forEach((e) => {
        if (e.orderNum && e.price) {
          this.price += e.orderNum * e.price;
        }
      });
      console.log(this.chooseArr);
    },
    //获取展位订单信息
    getExhibitionBooth() {
      if (
        this.exhibitionArea.length > 0 &&
        this.exhibitionArea[this.exAreaIndex].dePjNameList.length > 0
      ) {
        this.exhibitionBooth =
          this.exhibitionArea[this.exAreaIndex].dePjNameList;
        this.exhibitionBooth.map((e) => {
          e.isCheck = false;
          e.Width = 0;
          e.Height = 0;
        });
      }
    },
    //获取固定订单
    async getOtherList() {
      this.chooseArr = [];
      this.gudingprice = 0;
      this.otherList = await this.getCommodities({
        exhibitionId: this.exhibitionId,
        isEnable: true,
        groupType: ["固定费用"],
      });

      this.otherList.map((c) => {
        this.fixedpriceAdd += c.price;
        c.isCheck = true;
      });
      if (otherList3 && otherList3.length > 0) {
        otherList3.forEach((e) => {
          // if (e.typeLanguage == "中文" && e.dePjNameList.length > 0) {

          e.dePjNameList.forEach((c) => {
            this.fixId = c.dePjNameGroupId;
            c.isCheck = true;
            this.gudingprice += c.minCount * c.price;
          });

          this.otherList = e.dePjNameList;

          // }
        });
        this.otherList.forEach((c) => {
          console.log(c, "ccc");
          this.chooseArr.push(c);
        });
      }
    },
    async geOnlineList() {
      this.onlineList = [];
      let zn = {
        IsBoothGroup: "否",
        ExhibitionId: this.exhibitionId,
        Type: "线上",
        TypeLanguage: this.currencyShow ? "英文" : "中文",
      };
      let en = {
        DeTermIdEx: this.DeTermIdEx ? this.DeTermIdEx : null,
        ptype: this.currencyTypeName ? this.currencyTypeName : null,
        IsBoothGroup: "否",
        ExhibitionId: this.exhibitionId,
        Type: "线上",
        TypeLanguage: this.currencyShow ? "英文" : "中文",
      };
      let opt = this.currencyShow ? en : zn;

      let otherList = await this.getForeignList(opt); // 是：展区选择展位； 否：增值服务项目
      console.log(otherList, "otherList");
      if (otherList && otherList.length > 0) {
        otherList.map((c) => {
          c.isPack = false;
          c.isCheck = false;

          if (c.dePjNameList.length > 0) {
            c.dePjNameList.map((d) => {
              d.orderNum = 0;
              d.durationValue = null;
              d.otherName = c.name;
              (d.beginTime = ""), (d.endTime = "");
              let start = new Date(d.durationBegin).getTime();
              let end = new Date(d.durationEnd).getTime();
              d.options = {
                disabledDate(date) {
                  const disabledDay = date.getTime();
                  if (disabledDay < start || disabledDay > end) {
                    return true;
                  } else {
                    return false;
                  }
                },
              };
            });
          }
        });
      }
      this.onlineList = otherList;
      this.onlineList.map((a) => {
        if (a.dePjNameList.length > 0) {
          a.dePjNameList.map((p) => {
            if (p.netShow == "显示且必选") {
              p.orderNum = 1;
              //this.chooseOne(p)
            }
          });
        }
      });
      console.log(this.onlineList, "线上");
    },
    //获取线下数组
    async geOfflineList() {
      this.offlineList = [];

      let zn = {
        IsBoothGroup: "否",
        ExhibitionId: this.exhibitionId,
        Type: "线下",
        TypeLanguage: this.currencyShow ? "英文" : "中文",
      };
      let en = {
        DeTermIdEx: this.DeTermIdEx ? this.DeTermIdEx : null,
        ptype: this.currencyTypeName ? this.currencyTypeName : null,
        IsBoothGroup: "否",
        ExhibitionId: this.exhibitionId,
        Type: "线下",
        TypeLanguage: this.currencyShow ? "英文" : "中文",
      };
      let opt = this.currencyShow ? en : zn;
      let otherList = await this.getForeignList(opt); // 是：展区选择展位； 否：增值服务项目

      if (otherList && otherList.length > 0) {
        otherList.map((c) => {
          c.isPack = false;
          c.isCheck = false;

          if (c.dePjNameList.length > 0) {
            c.dePjNameList.map((d) => {
              d.orderNum = 0;
              d.durationValue = null;
              d.otherName = c.name;
              (d.beginTime = ""), (d.endTime = "");
              let start = new Date(d.durationBegin).getTime();
              let end = new Date(d.durationEnd).getTime();
              d.options = {
                disabledDate(date) {
                  const disabledDay = date.getTime();
                  if (disabledDay < start || disabledDay > end) {
                    return true;
                  } else {
                    return false;
                  }
                },
              };
            });
          }
        });
      }
      this.offlineList = otherList;
      this.offlineList.map((a) => {
        if (a.dePjNameList.length > 0) {
          a.dePjNameList.map((p) => {
            if (p.netShow == "显示且必选") {
              p.orderNum = 1;
              //this.chooseOne(p)
            }
          });
        }
      });
      console.log(this.offlineList, "线上");
    },
    //获取展会
    async getExhibition() {
      let idsToDelete = [
        "ebd24211-4119-4b47-afb2-9647c325ebab",
        "a3741b45-d5ee-46dc-8a94-2e2577ad5ee0",
        "ab24aee3-ad4f-438c-9f8f-4816d2ef0865",
        "46f6f63d-e30a-4386-b190-0e4c4ba06827",
        "71b57cf1-e617-4912-9ea9-b17eab06e375",
        "949e3761-b303-4597-8bec-3f206913a86d",
      ];

      let list = await this.getApplyExhibition();

      this.exhibitionList = list.filter((obj) => !idsToDelete.includes(obj.id));
      this.exhibitionId = this.exhibitionList[0].id;
      if (this.exhibitionId) {
        this.getExhibtionArea(this.exhibitionId);
        this.getDeTermGetList(this.exhibitionId);
        // this.getOtherList();
        // this.geOnlineList();
        // this.geOfflineList()
        this.getCost_Fixed();
        this.getCost_onlineOffline();
        this.getCost_onlineOfflineDown();
      }
    },
    //获取展会的展区
    async getExhibtionArea(id) {
      // 展位、增值服务
      let list = await this.getAllArea(id);

      if (list) {
        this.exhibitionArea = list;
        this.exhibitionAreaId = list[0].id;
        this.exAreaIndex = 0;
        // this.exhibitionAreaId = list[0].id;
        this.getOtherList1(list[0].id, list[0]);
        this.changeLoading = false;
      }
      // this.getExhibitionBooth();
    },
    //获取id : 768  根据id  获取固定费用和增值订单
    async getDeTermGetList(id) {
      // let list = await this.getDeTermGetListByType({
      //   ExhibitionId: id,
      // });
      // if (list) {
      //   this.getDeTermGetListId = list;
      // }
    },
    //改变展会
    changeEx(id, index) {
      // if (index == 0) {
      //   this.directImportList = [
      //     {
      //       name: "International Sales",
      //     },
      //     {
      //       name: "International Pavilion",
      //     },
      //   ];
      //   this.directImportList[0].name = "International Sales";
      // }

      // if (index == 1) {
      //   // this.directImportList = [
      //   //   {
      //   //     // name: 'International direct sales'
      //   //     name: "ICMD International",
      //   //   },
      //   // ];

      //   this.directImportList = [
      //     {
      //       name: "International Sales",
      //     },
      //     {
      //       name: "International Pavilion",
      //     },
      //   ];

      //   this.directImportList[0].name = "International Sales";
      //   this.pavilion = false;
      //   this.directImportIndex = 6;
      // }

      // if (index == 2) {
      //   this.directImportList = [
      //     {
      //       name: "CRS International",
      //     },
      //     {
      //       name: "International Pavilion",
      //     },
      //   ];

      //   this.directImportList[0].name = "CRS International";
      // }

      // if (index == 5 || index == 4) {
      //   this.directImportList = [
      //     {
      //       name: "ICMD International",
      //     },
      //     {
      //       name: "International Pavilion",
      //     },
      //   ];

      //   this.directImportList[0].name = "ICMD International";
      // }
      //   判断是否是中英文

      this.currencyShow = false;
      this.currencyTypeName = "";
      this.currencyIndex = 3;
      this.directImportIndex = 3;
      this.pavilionIndex = 30;
      this.offlineList = [];
      this.onlineList = [];

      // this.exhibitionBooth = [];

      if (this.changeLoading == true) {
        return;
      }
      this.changeLoading = true;

      this.exhibitionArea = [];
      this.inputShow = false;
      this.exIndex = index;
      this.exhibitionId = id;
      this.getExhibtionArea(id);
      console.log(this.exhibitionArea);
      if (
        this.exhibitionArea.length > 0 &&
        this.exhibitionArea[0].name.indexOf("其他") !== -1
      ) {
        this.inputShow = true;
      } else {
        this.inputShow = false;
      }
      this.exAreaIndex = 50;
      this.price = 0;
      this.boothprice = 0;
      this.boothSelect = [];
      this.chooseArr = [];
      // this.getOtherList();
      // this.geOnlineList();
      // this.geOfflineList()
      this.getCost_Fixed();
      this.getCost_onlineOffline();
      this.getCost_onlineOfflineDown();
      this.getDeTermGetList(id);
    },
    //改变展区
    changeExArea(id, index, name, item) {
      // if (
      //   name.indexOf("国际区") !== -1 ||
      //   name.indexOf("International") !== -1
      // ) {
      //   this.currencyShow = true;
      //   this.languageEnListCurrent = this.currencyShow ? "英文" : "中文";
      //   if (this.directImportName == "International Pavilion") {
      //     this.pavilion = true;
      //   }
      // } else {
      //   this.currencyShow = false;
      //   this.pavilion = false;
      // }

      this.exhibitionAreaId = id;
      this.exAreaIndex = index;
      this.price = 0;
      this.boothprice = 0;
      this.boothSelect = [];
      this.chooseArr = [];
      if (name.indexOf("其他") !== -1) {
        this.inputShow = true;
      } else {
        this.inputShow = false;
      }
      this.getOtherList1(id, item);
      this.getCost_Fixed();
      this.getCost_onlineOffline();
      this.getCost_onlineOfflineDown();
      // this.getExhibitionBooth();
      // this.getOtherList();

      this.DeTermIdEx = "";

      // this.geOnlineList();
      // this.geOfflineList();
    },
    async getOtherList1(id, item) {
      let res = await this.getCommodities({
        exhibitionId: this.exhibitionId,
        areaId: id,
        isEnable: true,
      });
      this.exhibitionBoothNew = JSON.parse(JSON.stringify(res));
      this.exhibitionBoothNew.map((c) => {
        c.width1 = 0;
        c.width2 = 0;
      });
      this.selectedExhall = item[0];

      // 如果有订单默认选中;
      if (this.orderInfo && this.orderInfo.applyBoothOrderList.length && item) {
        item.forEach((c) => {
          if (c.id == this.orderInfo.applyBoothOrderList[0].dePjNameGroupId) {
            this.selectedExhall = c;
            console.log(this.selectedExhall, "这个是选中的数据");
            //   if (this.selectedExhall.name.indexOf('其他') != -1) {
            //       this.inputShow = true
            //       this.remark = orderInfo.remark
            //   }
          }

          this.exhibitionBoothNew.map((c) => {
            if (
              this.orderInfo &&
              this.orderInfo.applyBoothOrderList.length &&
              item
            ) {
              if (c.name == this.orderInfo.applyBoothOrderList[0].name) {
                //   this.boothList = c.dePjNameLis
                this.chooseBooth = c;
                if (this.chooseBooth) {
                  this.chooseBooth.width1 =
                    this.orderInfo.applyBoothOrderList[0].width;
                  this.chooseBooth.width2 =
                    this.orderInfo.applyBoothOrderList[0].height;
                }
              }
            }
          });

          //   线上/线下 市场增值服务项目回显
          if (
            this.orderInfo &&
            this.orderInfo.applyOtherOrderList.length &&
            item
          ) {
            this.onlineOfflineCostList.map((v) => {
              this.orderInfo.applyOtherOrderList.map((b) => {
                if (v.name == b.name) {
                  v.orderNum = b.quantity;
                  v.isCheck = true;
                  v.isPack = true;
                }
              });
            });
          }
        });
      }
      console.log(this.exhibitionBoothNew, "展区");
    },
    async getCost_Fixed(id) {
      this.fixedpriceAdd = 0;
      this.otherList = await this.getCommodities({
        exhibitionId: this.exhibitionId,
        isEnable: true,
        groupType: ["固定费用"],
      });
      this.gudingprice = 0;
      this.otherList.map((c) => {
        if (c.isEnable && this.languageEnListCurrent == c.groupLanguage) {
          console.log(c, 111111111111);
          this.fixedpriceAdd += c.price;
          this.gudingprice += c.price;
        }

        c.isCheck = true;
      });

      console.log(this.otherList, "获取的固定费用");
    },

    async getCost_onlineOffline(id) {
      this.onlineList = await this.getCommodities({
        exhibitionId: this.exhibitionId,
        isEnable: true,
        groupType: ["线上"],
      });
      this.onlineList.map((c) => {
        c.isPack = false;
        c.isCheck = false;
        c.orderNum = 0;
      });
      console.log(this.onlineList, "获取的线上费用");
    },
    async getCost_onlineOfflineDown(id) {
      this.offlineList = await this.getCommodities({
        exhibitionId: this.exhibitionId,
        isEnable: true,
        groupType: ["线下"],
      });
      this.offlineList.map((c) => {
        c.isPack = false;
        c.isCheck = false;
        c.orderNum = 0;
      });
      console.log(this.offlineList, "获取的线下费用");
    },
    changeBox(item, e, index) {
      console.log(item, e, index, 1111111111);
      let arr = this.exhibitionBoothNew;
      arr.forEach((c) => {
        c.isCheck = false;
        if (item.id == c.id) {
          c.isCheck = e;
        }
      });
      item.Height = 0;
      item.Width = 0;

      this.$nextTick(() => {
        this.exhibitionBoothNew = JSON.parse(JSON.stringify(arr));
      });
      this.boothSelect = item;
      this.boothprice = 0;

      console.log(this.boothSelect, 11111111111);
    },
    async init() {
      this.getExhibition();
    },
    //根据错误定位
    goFail(ElepropName) {
      Element.prototype.documentOffsetTop = function () {
        return (
          this.offsetTop +
          (this.offsetParent ? this.offsetParent.documentOffsetTop() : 0)
        );
      };
      console.log(ElepropName, "ElepropName");
      let top =
        document.getElementById(ElepropName).documentOffsetTop() -
        window.innerHeight / 2;
      window.scrollTo(0, top);
      return;
    },

    //校验邮箱格式
    checkEmail(email) {
      return RegExp(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/).test(
        email
      );
    },
    checkPhone(phone) {
      return RegExp(11 && /^1\d{10}$/).test(phone);
    },

    //基本信息报名
    async apply() {
      this.display = true;
      let req = {
        companyName: this.company,
        linkMan: this.name,
        linkTitle: this.job,
        linkMob: this.phone,
        linkEmail: this.Email,
        address: this.address,
        leaderEmail: this.Email,
        unifiedCode: this.creditCode,
        // 发票
        isInvoice: this.singleInvoicing,
        invoiceType: this.invoiceType,
        invoiceTitle: this.invoiceTitle,
        invoiceCode: this.invoiceCode,
        invoiceAddress: this.invoiceAddress,
        invoiceTelephone: this.invoiceTelephone,
        invoiceBank: this.invoiceBank,
        invoiceBankAccount: this.invoiceBankAccount,
      };
      let bool = await this.addApplyCompany(JSON.stringify(req));
      if (bool && bool.successed) {
        this.applyCompanyId = bool.info;
        this.applyEx();
      } else {
        this.display = false;
      }
    },
    //直销展位报名
    async applyEx() {
      let req = {
        ApplyCompanyId: this.applyCompanyId,
        ExhibitionId: this.exhibitionId,
        IsAgent: "否",
        AgentName: "",
      };
      let bool = await this.applyCompanyOrder(req);
      if (bool && bool.successed) {
        this.applyCompanyOrderId = bool.info.id;
        this.applyOrder();
      } else {
        this.display = false;
        this.$Message.warning("您已完成报名请耐心等待组委会通知");
      }
    },
    //创建展位订单
    async applyOrder() {
      let ApplyOtherOrderList = [];
      console.log(this.chooseArr, "chooseArr");
      this.chooseArr = Array.from(new Set(this.chooseArr));

      if (this.chooseArr && this.chooseArr.length > 0) {
        this.chooseArr.map((c) => {
          // if (c.durationType === "时长") {
          //   ApplyOtherOrderList.push({
          //     ApplyCompanyOrderId: this.applyCompanyOrderId,
          //     DePjNameGroupId: c.dePjNameGroupId,
          //     DePjNameGroupName: c.otherName,
          //     ThirdPartyCommodityId: c.id,
          //     Name: c.pjName,
          //     Quantity: c.orderNum,
          //     Unit: c.cunit,
          //     UnitPrice: c.price,
          //     TotalPrice: c.orderNum * c.price,
          //     MonetaryUnit: c.pType,
          //     DurationType: c.durationType,
          //     Duration: Number(c.durationValue),
          //     DurationUnit: c.durationUnit,
          //     RexMoney: c.orderNum * c.price,
          //     GpName: c.gpName || "",
          //     GpCode: c.gpCode || "",
          //     PjCode: c.pjCode || "",
          //     GroupId: c.groupId || "",
          //     PjFormat: c.pjFormat || "",
          //   });
          // }
          // if (c.durationType === "时间段") {
          //   ApplyOtherOrderList.push({
          //     ApplyCompanyOrderId: this.applyCompanyOrderId,
          //     DePjNameGroupId: c.dePjNameGroupId,
          //     DePjNameGroupName: c.otherName,
          //     Name: c.pjName,
          //     Quantity: c.orderNum,
          //     Unit: c.cunit,
          //     UnitPrice: c.price,
          //     TotalPrice: c.orderNum * c.price,
          //     MonetaryUnit: c.pType,
          //     DurationType: c.durationType,
          //     DurationBegin: moment(c.beginTime).format("YYYY-MM-DD"),
          //     DurationEnd: moment(c.endTime).format("YYYY-MM-DD"),
          //     RexMoney: c.orderNum * c.price,
          //     GpName: c.gpName || "",
          //     GpCode: c.gpCode || "",
          //     PjCode: c.pjCode || "",
          //     GroupId: c.groupId || "",
          //     PjFormat: c.pjFormat || "",
          //   });
          // } else {
          //   ApplyOtherOrderList.push({
          //     ApplyCompanyOrderId: this.applyCompanyOrderId,
          //     DePjNameGroupId: c.dePjNameGroupId,
          //     DePjNameGroupName: "固定费用",
          //     Name: c.pjName,
          //     Quantity: c.orderNum ? c.orderNum : 1,
          //     Unit: c.cunit,
          //     UnitPrice: c.price,
          //     TotalPrice: c.price,
          //     MonetaryUnit: c.pType,
          //     DurationType: c.durationType,
          //     DurationBegin: moment(c.durationBegin).format("YYYY-MM-DD"),
          //     DurationEnd: moment(c.durationEnd).format("YYYY-MM-DD"),
          //     RexMoney: c.price,
          //     GpName: c.gpName || "",
          //     GpCode: c.gpCode || "",
          //     PjCode: c.pjCode || "",
          //     GroupId: c.groupId || "",
          //     PjFormat: c.pjFormat || "",
          //   });
          // }
          ApplyOtherOrderList.push({
            ApplyCompanyOrderId: this.applyCompanyOrderId,
            DePjNameGroupId: c.dePjNameGroupId,
            DePjNameGroupName: c.groupType,
            ThirdPartyCommodityId: c.id,
            Name: c.name,
            Quantity: c.orderNum ? c.orderNum : 0, //填的数量
            Unit: c.unit,
            UnitPrice: c.price,
            TotalPrice: c.orderNum ? c.price * c.orderNum : 0,
            MonetaryUnit: c.currencyKind,
            DurationType: "",
            DurationBegin: moment(new Date()).format("YYYY-MM-DD"),
            DurationEnd: moment(new Date()).format("YYYY-MM-DD"),
            Rex: 1,
            RexMoney: c.orderNum ? c.price * c.orderNum : 0,
            GpName: c.kindName,
            GpCode: "",
            GroupId: 1,
            PjCode: "",
            PjFormat: "",
          });
        });
      }
      if (this.otherList && this.otherList.length > 0) {
        this.otherList.map((c) => {
          if (c.isEnable && this.languageEnListCurrent == c.groupLanguage) {
            ApplyOtherOrderList.push({
              ApplyCompanyOrderId: this.applyCompanyOrderId,
              DePjNameGroupId: c.dePjNameGroupId,
              DePjNameGroupName: c.groupType,
              ThirdPartyCommodityId: c.id,
              Name: c.name,
              Quantity: c.orderNum ? c.orderNum : 1,
              Unit: c.unit,
              UnitPrice: c.price,
              TotalPrice: c.price,
              MonetaryUnit: c.currencyKind,
              DurationType: "",
              DurationBegin: moment(new Date()).format("YYYY-MM-DD"),
              DurationEnd: moment(new Date()).format("YYYY-MM-DD"),
              Rex: 1,
              RexMoney: c.price,
              GpName: "",
              GpCode: "",
              GroupId: 1,
              PjCode: "",
              PjFormat: "",
            });
          }
        });
      }
      console.log(ApplyOtherOrderList, "ApplyOtherOrderList");
      // const hash = {};
      // const newArray = ApplyOtherOrderList.reduce((item, next) => {
      //   hash[next.PjCode] ? "" : (hash[next.PjCode] = true && item.push(next));
      //   return item;
      // }, []);
      // console.info("去重后的数组:", newArray);
      if (this.boothprice == 0) {
        this.$Message.fail("展位金额计算失败，请刷新后再试...");
        return;
      }
      // ApplyOtherOrderList = newArray;

      let req = {
        Id: this.applyCompanyOrderId,
        ApplyCompanyId: this.applyCompanyId,
        ExhibitionId: this.exhibitionId,
        // ExhibitionId: 'D2F77A00-C615-4CB6-85B4-3058F515C0AB',
        IsAgent: "否",
        Remark: this.remark,
        ApplyBoothOrderList: [
          {
            ApplyCompanyOrderId: this.applyCompanyOrderId,
            DePjNameGroupId: this.exhibitionAreaId,
            DePjNameGroupName: this.exhibitionArea[this.exAreaIndex].name,
            Name: this.boothSelect.name,
            Width: this.boothSelect.Width,
            Height: this.boothSelect.Height,
            ThirdPartyCommodityId: this.boothSelect.id,
            Area: this.boothSelect.Width * this.boothSelect.Height,
            Unit: this.boothSelect.unit,
            UnitPrice: this.boothSelect.price,
            TotalPrice: this.boothprice,
            MonetaryUnit: this.boothSelect.currencyKind,
            IsAgent: "否",
            Rex: 1,
            RexMoney:
              this.boothSelect.Width *
              this.boothSelect.Height *
              this.boothSelect.price,
            GpName: this.boothSelect.kindName,
            GpCode: "",
            GroupId: 1,
            PjCode: "",
            PjFormat: "",
            BoothType: this.boothSelect.boothKind || "",
          },
        ],
        ApplyOtherOrderList: ApplyOtherOrderList,
      };
      if (this.boothSelect.boothArea > 1) {
        req.ApplyBoothOrderList[0].TotalPrice = (
          (this.boothSelect.Width *
            this.boothSelect.Height *
            this.boothSelect.price) /
          parseInt(this.boothSelect.boothArea)
        ).toFixed();

        req.ApplyBoothOrderList[0].RexMoney = (
          (this.boothSelect.Width *
            this.boothSelect.Height *
            this.boothSelect.price) /
          parseInt(this.boothSelect.boothArea)
        ).toFixed();
      }

      let info = await this.addApplyOrder(req);
      if (info && info.successed) {
        let req1 = {
          applycompanyId: this.applyCompanyId,
          exhibitonid: this.exhibitionId,
        };
        let bool1 = await this.OrderChangeState(req1);
        this.finished();
      } else {
        this.display = false;
        this.$Message.error("订单与展会不符合，请重新选择展会");
      }
    },
    async finished() {
      let req = {
        Id: this.applyCompanyOrderId,
        // ApplyFileLink: this.uploadList[0].url
        ApplyFileLink: "finished",
      };
      let bool = await this.finishApplyOperate(req);
      if (bool && bool.successed) {
        this.display = false;
        this.$Message.success("提交成功！/Submitted successfully！");
        setTimeout(() => {
          this.$router.push({
            path: "/HomeMobile-success",
            query: { userId: this.applyCompanyId },
          });
        }, 1500);
      } else {
        this.display = false;
        this.$Message.fail("提交失败/Submission failed");
      }
    },
    async submit() {
      console.log(this.exhibitionAreaId, "exhibitionAreaId");
      if (!this.company) {
        this.$Message.info("请输入公司/Please enter Company Name");
        this.goFail("company");

        return;
      }
      if (!this.name) {
        this.$Message.info("请输入联系人/Please enter Contact");
        this.goFail("name");

        return;
      }
      if (!this.job) {
        this.$Message.info("请输入职务/Please enter Position");
        this.goFail("job");
        return;
      }
      if (!this.currencyShow) {
        if (!this.phone) {
          this.$Message.info("请输入手机号/Please enter contact number");
          this.goFail("phone");
          return;
        } else {
          let bool = this.checkPhone(this.phone);
          if (!bool) {
            this.$Message.info(
              "请输入正确的手机号/Please enter the correct mobile number"
            );
            return;
          }
        }
      }

      if (!this.Email) {
        this.$Message.info("请输入邮箱/Please enter Email");
        this.goFail("email");
        return;
      } else {
        let bool = this.checkEmail(this.Email);
        if (!bool) {
          this.$Message.info(
            "请输入正确的邮箱/Please enter the correct mailbox"
          );
          return;
        }
      }
      if (!this.address) {
        this.$Message.info("请输入地址/Please enter Country");
        this.goFail("address");

        return;
      }
      if (!this.currencyShow) {
        if (!this.creditCode) {
          this.$Message.info("请输入信用代码/Please enter Social Credi");
          this.goFail("creditCode");
          return;
        } else {
          if (
            this.creditCode.length === 15 ||
            this.creditCode.length === 18 ||
            this.creditCode.length === 20
          ) {
          } else {
            this.$Message.info(
              "请输入正确的社会信用代码/Please enter the correct social credit code"
            );
            return;
          }
        }
      }

      if (!this.singleInvoicing && !this.invoiceType) {
        this.$Message.info("请选择发票类型");
        return;
      }
      if (!this.singleInvoicing && this.invoiceType) {
        if (this.invoiceType == "增值税专用发票" && !this.invoiceTitle) {
          this.$Message.info("请输入发票抬头");
          return;
        }
        if (this.invoiceType == "增值税专用发票" && !this.invoiceCode) {
          this.$Message.info("请输入税号");
          return;
        }
        if (!this.invoiceAddress) {
          this.$Message.info("请输入单位地址");
          return;
        }
        if (!this.invoiceTelephone) {
          this.$Message.info("请输入电话号码");
          return;
        }
        // else {
        //   let bool = this.checkPhone(this.invoiceTelephone);
        //   if (!bool) {
        //     this.$Message.info("请输入正确的电话号码");
        //     return;
        //   }
        // }
        if (!this.invoiceBank) {
          this.$Message.info("请输入开户银行");
          return;
        }
        if (!this.invoiceBankAccount) {
          this.$Message.info("请输入银行账户");
          return;
        }
      }

      if (this.currencyShow) {
        if (!this.currencyTypeName) {
          this.$Message.info("Please select currency");
          return;
        }
        if (!this.directImportName) {
          this.$Message.info("Please select your exhibition group");
          return;
        }
        if (this.directImportName != this.directImportList[0].name) {
          if (!this.pavilionName) {
            this.$Message.info("Continue to select the pavilion");
            return;
          }
        }
      }

      if (this.boothSelect.length < 1) {
        if (this.currencyShow) {
          this.$Message.info("Please select  booth type");
        } else {
          this.$Message.info("请选择一个展位类型");
        }

        this.goFail("booth");
        this.display = false;
        return;
      }

      if (this.boothSelect.Width == 0 || this.boothSelect.Height == 0) {
        // this.$Message.warning("请输入展位宽度和进深");
        if (this.currencyShow) {
          this.$Message.info("Please enter the booth width and depth");
        } else {
          this.$Message.warning("请输入展位宽度和进深");
        }
        this.display = false;
        return;
      }

      if (this.chooseArr && this.chooseArr.length > 0) {
        let finish = true;
        this.chooseArr.map((c) => {
          // if (!c.durationValue && c.durationType == "时长") {
          //   finish = false;
          //   this.$Message.warning("请选择" + c.pjName + "的" + c.durationType);
          //   return;
          // }
          // if (
          //   c.durationType === "时间段" &&
          //   (!c.beginTime || !c.endTime) &&
          //   c.durationType != "无"
          // ) {
          //   finish = false;
          //   this.$Message.warning("请选择" + c.pjName + "的" + c.durationType);
          //   return;
          // }
          // if (!c.orderNum && c.dePjNameGroupId != this.fixId) {
          //   finish = false;
          //   this.$Message.warning("请输入" + c.name + "的订购数量");
          //   return;
          // }
        });
        console.log(this.chooseArr, "数组改变没");

        if (!finish) return;
      }
      if (this.inputShow && !this.remark) {
        console.log(this.remark);
        this.$Message.warning("请输入产品类型");
        this.display = false;
        return;
      }

      this.apply();
      //   if (res.successed) {
      //     this.$router.push({ path: "/HomeMobile-success" });
      //   }
    },

    async changeCurrency(item, index) {
      this.currencyIndex = index;
      this.currencyTypeName = item.name;
      this.changePTypeGong();

      // this.getOtherList();
    },

    async changeDirectImport(item, index) {
      this.getDeTermGetListId.map((q) => {
        if (q.term == item.name) {
          this.DeTermIdEx = q.id;
        }
      });

      this.directImportIndex = index;
      this.directImportName = item.name;

      if (item.name == "International Pavilion") {
        this.pavilion = true;
        //除去固定的展区
        this.languageEnListOther = [];
        this.exhibitionArea.map((p) => {
          if (p.typeLanguage == "英文") {
            if (p.name != this.directImportList[0].name) {
              this.languageEnListOther.push(p);
            }
          }
        });
      } else {
        this.changePTypeGong();
        this.pavilionName = "";
        this.pavilion = false;
      }
      // this.getOtherList();
      // this.geOnlineList();
      // this.geOfflineList();
    },
    async changePavilion(item, index) {
      this.getDeTermGetListId.map((q) => {
        if (q.term == item.name) {
          this.DeTermIdEx = q.id;
        }
      });

      this.pavilionIndex = index;
      this.pavilionName = item.name;

      // this.exhibitionBooth = [];

      this.languageEnListOther.map((j) => {
        if (this.pavilionName == j.name) {
          j.dePjNameList.map((o) => {
            if (o.pType == this.currencyTypeName) {
              this.exhibitionBooth.push(o);
            }
          });
        }
      });
      this.exhibitionBooth.map((e) => {
        e.isCheck = false;
        e.Width = 0;
        e.Height = 0;
      });
      console.log(this.languageEnListOther, "languageEnListOther");
      // this.getOtherList();
      // this.geOnlineList();
      // this.geOfflineList();
    },

    // 切换币种 用到的公用方法
    changePTypeGong() {
      // this.geOnlineList();
      // this.geOfflineList();
      this.getCost_onlineOffline();
      this.getCost_onlineOfflineDown();
      // 筛选出来英文订单  和币种相同的订单  展示在页面上   展位预定用的数组就是exhibitionBooth
      // this.exhibitionBooth = [];
      this.languageEnList = [];
      this.showEnOrderList = [];

      this.exhibitionArea.map((e) => {
        if (e.name == this.directImportList[0].name) {
          if (e.typeLanguage == "英文") {
            this.languageEnList = e.dePjNameList;
          }
        }
      });

      this.languageEnList.map((i) => {
        if (i.pType == this.currencyTypeName) {
          this.exhibitionBooth.push(i);
        }
      });
      this.exhibitionBooth.map((e) => {
        e.isCheck = false;
        e.Width = 0;
        e.Height = 0;
      });

      console.log(this.exhibitionBooth, "exhibitionBooth");
    },
  },
};
</script>

<style scoped lang="scss">
.top {
  background-color: #fff;
  position: relative;
  padding: 0.3rem;
  font-size: 0.26rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333;
  border-bottom: 1px solid #e5e5e5;

  .l {
    display: flex;
    width: 80%;
  }

  .r {
    cursor: pointer;
    display: flex;
    align-items: center;

    i {
      font-size: 0.26rem;
      margin-left: 5px;
    }
  }
}

/deep/.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  font-size: 0.24rem;
  height: 0.5rem;
  line-height: 0.5rem;
}

/deep/.ivu-select-item {
  font-size: 0.24rem !important;
}

/deep/.ivu-select-single .ivu-select-selection {
  height: 0.5rem;
}

/deep/.ivu-select {
  font-size: 0.24rem;
}

/deep/.ivu-select-single .ivu-select-selection .ivu-select-placeholder,
.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.24rem;
}

/deep/ .ivu-input {
  font-size: 0.24rem;
}

/deep/ .ivu-checkbox-checked .ivu-checkbox-inner:after {
  width: 6px;
  height: 8px;
  left: 4px;
}

/deep/ .ivu-checkbox {
  .ivu-checkbox-inner {
    width: 0.3rem;
    height: 0.3rem;
  }
}

::v-deep {
  .ivu-input {
    height: 0.8rem;
  }
}

.header {
  height: 1rem;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  span {
    font-size: 0.3rem;
  }
}

.title {
  font-size: 0.3rem;
  color: #353535;
  background-color: #f2f2f2;
  padding: 0.36rem 0 0rem 0.3rem;
}

.content {
  padding: 0 0.3rem;

  .cell {
    padding: 0.24rem 0;
    border-bottom: 1px solid #e5e5e5;

    span {
      color: #353535;
      font-size: 0.3rem;
      width: 3.2rem;
      display: inline-block;
    }

    input {
      border: 0px;
      outline: none;
      width: 4.5rem;
    }
  }
}

.exhibitionarea {
  padding: 0.3rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: -0.28rem;

  .exhibition1 {
    background-color: #fff;
    border-radius: 0.1rem;
    border: solid 1px #e6e6e6;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.2rem;
    margin-right: 0.28rem;
    padding: 0.2rem;

    .span1 {
      font-size: 0.24rem;
      color: #666;
    }

    &.is_active {
      border: solid 1px #ee1c5d;

      .span1 {
        color: #ee1c5d;
      }
    }
  }

  .exhibitionInvoice {
    background-color: #fff;
    border-radius: 0.1rem;
    border: solid 1px #ee1c5d;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.1rem;
    margin-right: 0.28rem;
    padding: 0.1rem;

    .span1 {
      font-size: 0.24rem;
      color: #ee1c5d;
      text-align: center;
    }

    &.is_active {
      border: solid 1px #ee1c5d;

      .span1 {
        color: #ee1c5d;
      }
    }
  }
}

.reserve {
  padding-left: 0.3rem;
  margin-top: 0.3rem;
  font-size: 0.26rem;
  position: relative;

  .reserve_span1 {
    color: #353535;
  }

  .reserve_span2 {
    color: #999;
  }

  .reserve_span3 {
    position: absolute;
    right: 0.2rem;
  }

  .selectInput {
    display: flex;
    align-items: center;
    margin-top: 0.15rem;
    margin-bottom: 0.2rem;
  }

  .icon {
    transform: scale(2);
    color: #666;
  }

  .icon_dis {
    color: #e5e5e5;
  }
}

.submitbtn {
  background-color: #f2f2f2;
  padding: 0.95rem 0.3rem 0.4rem;

  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.88rem;
    background-color: #ee1c5d;
    border-radius: 3rem;

    span {
      font-size: 0.3rem;
      color: #fff;
    }
  }

  .btn-dis {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.88rem;
    background-color: #f5f5f5;
    border-radius: 3rem;

    span {
      font-size: 0.3rem;
      color: #fff;
    }
  }
}

.ivu-checkbox-checked .ivu-checkbox-inner {
  border-color: #2d8cf0;
  background-color: #2d8cf0;
}

.ivu-checkbox-checked:hover .ivu-checkbox-inner {
  border-color: #2d8cf0;
}

.area {
  margin-top: 0.5rem;
  padding-left: 0.3rem;
  font-size: 0.24rem;

  &-title {
    color: #353535;
    font-size: 0.26rem;
  }

  input {
    font-size: 0.24rem;
    height: 64px;
  }
}

.cell {
  input {
    font-size: 0.24rem;
  }
}

.careful {
  color: #ee1c5d;
  font-size: 0.24rem;
  text-align: center;
}

.table {
  font-size: 0.24rem;
  padding-left: 0.7rem;

  &-child {
    margin-top: 0.4rem;
  }
}

.loadingText {
  font-size: 0.24rem;
  text-align: center;
  padding: 0.2rem;
}

.updataCss {
  margin: 0.2rem;
  background: #fff;
  border-radius: 0.2rem;
}

.invoiceRadio {
  margin-bottom: 0.2rem;
}

/deep/ .ivu-radio-inner {
  width: 0.26rem;
  height: 0.26rem;
}

/deep/ .ivu-radio-group {
  margin-bottom: 0.3rem;
}

/deep/ .ivu-radio-wrapper {
  font-size: 0.26rem;
  border: 1px solid #e5e5e5;
  padding: 0.26rem 0.26rem 0.5rem 0.26rem;
  width: 700px;
}

/deep/ .ivu-radio-inner:after {
  left: 0.07rem;
  top: 0.07rem;
}
</style>
